'use strict';

var noop = require('./noop');

module.exports = function authenticatedFlow(token) {
    return {
        authenticate: function() {
            throw new Error('Cannot authenticate');
        },
        getToken: function() {
            return token;
        },
        refreshToken: noop
    };
};



//////////////////
// WEBPACK FOOTER
// ./lib/auth/authenticated-flow.js
// module id = 66
// module chunks = 0